import { isMinor } from '../../Helpers/Helpers';

const digitalFormsBaseUrl = 'DigitalForms';

export const getLLSFunds = async (axiosGet, assistanceProgramId) => {
    return await axiosGet(`${digitalFormsBaseUrl}/LLSFunds/${assistanceProgramId}`);
}

export const LLSLivingInUSSpecialRule = (value, ctx) => {
    if (value?.toLowerCase() === 'no') {
        ctx.specialRuleChangeData('Patient_US', value, 'Patient must be a U.S citizen, or reside in the U.S. or a U.S. Territory in order to be eligible for the program.');
    }
}

export const LLSInsuranceCoverageSpecialRule = (value, ctx) => {
    if (value?.toLowerCase() === 'no') {
        ctx.specialRuleChangeData('Insurance_Does_Patient_Have_Medical_Insurance', value, 'Patient must have medical and/or prescription drug coverage in order to be eligible for the program.');
    }
}

export const LLSActiveTreatmentSpecialRule = (value, ctx) => {
    if (value?.toLowerCase() === 'no') {
        ctx.specialRuleChangeData('Patient_Treatment', value, 'The patient must be in active treatment, scheduled to begin treatment, or under follow-up care for their blood cancer diagnosis.');
    }
}

export const LLSOtherPreferNotToDiscloseRace = (value, ctx) => {
    const raceField = 'Patient_Race';
    const raceOtherField = 'Race_Specify'
    const raceValue = ctx.formData[raceField];

    if (raceValue == null || value == null) return;
    //formData is already being set before it comes into this rule
    //to know the order of what was clicked, you have to note the order of items in the array
    //first index = first item clicked

    //if prefer not to disclose is already checked but you are checking another item
    if (raceValue[0] === 'Prefer not to disclose' && raceValue.length > 1) {
        ctx.formData[raceField] = raceValue.filter(item => item !== 'Prefer not to disclose')
    }
    //if other race items are already checked and you select prefer not to disclose
    else if (raceValue.length > 1 && raceValue[raceValue.length - 1] === 'Prefer not to disclose') {
        ctx.formData[raceField] = ['Prefer not to disclose'];
    }

    //if first item clicked is prefer not to disclose then other is clicked, show other field
    if (raceValue[0] === 'Prefer not to disclose' && value?.includes('Other')) {
        ctx.specialRulePerformAction('show', [raceOtherField]);
        ctx.specialRulePerformAction('require', [raceOtherField]);
    }
    //if other is clicked and anything other than prefer not to disclose is clicked, show other field
    else if (value?.includes('Other') && !value?.includes('Prefer not to disclose')) {
        ctx.specialRulePerformAction('show', [raceOtherField]);
        ctx.specialRulePerformAction('require', [raceOtherField]);
    }
    else {
        ctx.specialRulePerformAction('hide', [raceOtherField]);
    }
}

export const LLSOnlyAlphabeticCharsSpacesHyphensAllowedSpecialRule = (value, ctx) => {
    if (!value) return;

    const invalidCharsReg = /[^a-zA-Z\- ]/gm;
    const hasInvalidCharacters = value.match(invalidCharsReg);
    const checkCharRestriction = ['Insurance Primary Subscriber Name', 'Insurance Secondary Subscriber Name'];

    if (hasInvalidCharacters) {
        const fieldsToCheck = GetFieldsToCheck(ctx, value, checkCharRestriction);
        fieldsToCheck.forEach(field => {
            const fieldValue = ctx.formData[field];
            ctx.specialRuleChangeData(field, fieldValue, 'Please remove numbers and/or special characters as they are not acceptable in the provider portal.');
        });
    }
}

export const LLSOnlyAlphabeticCharsAndSpacesAllowedSpecialRule = (value, ctx) => {
    if (!value) return;

    const invalidCharsReg = /[^a-zA-Z ]/gm;
    const hasInvalidCharacters = value.match(invalidCharsReg);
    const checkCharRestriction = ['Provider Physician City', 'Provider Physician Name First', 'Provider Physician Name Last'];
    //const checkCharMinimumArr4 = ['Provider Physician City'];

    if (hasInvalidCharacters) {
        const fieldsToCheck = GetFieldsToCheck(ctx, value, checkCharRestriction);
        fieldsToCheck.forEach(field => {
            const fieldValue = ctx.formData[field];
            ctx.specialRuleChangeData(field, fieldValue, 'Please remove numbers and/or special characters as they are not acceptable in the provider portal.');
        });
    }
    /*else {
        const fieldsToCheck = GetFieldsToCheck(ctx, value, checkCharMinimumArr4);
        fieldsToCheck.forEach(field => {
            const fieldValue = ctx.formData[field];
            if (fieldValue.trim().length < 4) {
                const fieldLabel = ctx.getFieldDef(field).label;
                ctx.specialRuleChangeData(field, fieldValue, `${fieldLabel} must contain at least 4 characters.`);
            }
        })
    }*/
}

export const initLLSAuthorizedContactRule = (ctx) => {
    const patientDOB = 'Patient DOB';
    const guardianDOB = 'Guardian_DOB';
    ctx.createSpecialRule(patientDOB, LLSGuardianContactRule);
    ctx.createSpecialRule(guardianDOB, LLSGuardianContactUnder18Rule);

    if (patientDOB) {
        const patientDOBAsDate = new Date(ctx.formData[patientDOB]);
        LLSGuardianContactRule(patientDOBAsDate, ctx);
    }

    if (guardianDOB) {
        const guardianDOBAsDate = new Date(ctx.formData[guardianDOB]);
        LLSGuardianContactUnder18Rule(guardianDOBAsDate, ctx);
    }
}

// these fields should only be visible and required if patient is a minor
export const LLSGuardianContactRule = (value, ctx) => {
    if (!value) return;

    const guardianFields = ['Guardian_Name_First', 'Guardian_Name_Last', 'Guardian_Suffix', 'Guardian_SSN', 'Guardian_DOB', 'Guardian_Relationship', 'Guardian_Employment',
        'Guardian_Address1', 'Guardian_Address2', 'Guardian_City', 'Guardian_State', 'Guardian_Zip', 'Guardian_Email',
        'Guardian_email_type', 'Guardian_Phone', 'Guardian_Phone_Type', 'Guardian_Address_Patient', 'Guardian_Phone_Patient']

    const action = isMinor(value) ? 'show' : 'hide';

    ctx.specialRulePerformAction(action, guardianFields);
}

export const LLSGuardianContactUnder18Rule = (value, ctx) => {
    if (!value) return;

    const guardianDOB = 'Guardian_DOB';

    if (isMinor(value)) {
        ctx.specialRuleChangeData(guardianDOB, value, 'Guardian must be over the age of 18 years old.');
    }
}



export const LLSOnlyAlphanumericSpacesHyphensAllowedSpecialRule = (value, ctx) => {
    if (!value) return;

    const invalidCharsReg = /[^a-zA-Z0-9 -]/gm;
    const hasInvalidCharacters = value.match(invalidCharsReg);
    const checkCharRestriction = ['Insurance Primary Medical Insurance ID_Policy Number', 'Insurance Primary Medical Insurance Group Number',
    'Insurance Secondary Medical Insurance ID_Policy Number', 'Insurance Secondary Medical Insurance Group Number', 'HF_Name', 'HP_Facility_Name'];
    //const checkCharMinimumArr3 = ['HF_Name', 'HP_Facility_Name']

    if (hasInvalidCharacters) {
        const fieldsToCheck = GetFieldsToCheck(ctx, value, checkCharRestriction);
        fieldsToCheck.forEach(field => {
            const fieldValue = ctx.formData[field];
            ctx.specialRuleChangeData(field, fieldValue, 'Please remove special characters as they are not acceptable in the provider portal.');
        });
    }
    /*else {
        const fieldsToCheck = GetFieldsToCheck(ctx, value, checkCharMinimumArr3);
        fieldsToCheck.forEach(field => {
            const fieldValue = ctx.formData[field];
            if (fieldValue.trim().length < 3) {
                const fieldLabel = ctx.getFieldDef(field).label;
                ctx.specialRuleChangeData(field, fieldValue, `${fieldLabel} must contain at least 3 characters.`);
            }
        })
    }*/
}

export const LLSOnlyAlphanumericHashHyphenSlashPeriodCommaFields = (value, ctx) => {
    if (!value) return;

    const invalidCharsReg = /[^a-zA-Z0-9 \-#/.,]/gm;
    const hasInvalidCharacters = value.match(invalidCharsReg);
    const checkCharRestriction = ['HF_Address1', 'HF_Address2', 'HP_Address1', 'HP_Address2', 'Authorized_Address_1', 'Authorized_Address_2', 'Patient Address 1',
        'Patient Address 2', 'Guardian_Address1', 'Guardian_Address2'];
    //const checkCharMinimumArr3 = ['HF_Address1', 'HP_Address1', 'Authorized_Address_1', 'Authorized_Address_2'];

    if (hasInvalidCharacters) {
        const fieldsToCheck = GetFieldsToCheck(ctx, value, checkCharRestriction);
        fieldsToCheck.forEach(field => {
            const fieldValue = ctx.formData[field];
            ctx.specialRuleChangeData(field, fieldValue, 'Please remove special characters as they are not acceptable in the provider portal.');
        });
    }
    /*else {
        const fieldsToCheck = GetFieldsToCheck(ctx, value, checkCharMinimumArr3);
        fieldsToCheck.forEach(field => {
            const fieldValue = ctx.formData[field];
            if (fieldValue.trim().length < 3) {
                const fieldLabel = ctx.getFieldDef(field).label;
                ctx.specialRuleChangeData(field, fieldValue, `${fieldLabel} must contain at least 3 characters.`);
            }
        })
    }*/
}

export const LLSOnlyAlphabeticHashHyphenSlashPeriodCommaFields = (value, ctx) => {
    if (!value) return;

    const invalidCharsReg = /[^a-zA-Z \-#/.,]/gm;
    const hasInvalidCharacters = value.match(invalidCharsReg);
    const checkCharRestriction = ['Refferred_Other'];

    if (hasInvalidCharacters) {
        const fieldsToCheck = GetFieldsToCheck(ctx, value, checkCharRestriction);
        fieldsToCheck.forEach(field => {
            const fieldValue = ctx.formData[field];
            ctx.specialRuleChangeData(field, fieldValue, 'Please remove numbers and/or special characters as they are not acceptable in the provider portal.');
        });
    }
}

export const LLSOnlyAlphabeticSpacesHyphensApostrophesAllowedSpecialRule = (value, ctx) => {
    if (!value) return;

    const invalidCharsReg = /[^a-zA-Z \-']/gm;
    const hasInvalidCharacters = value.match(invalidCharsReg);
    const checkCharRestriction = ['Patient Name First', 'Patient Name Last'];

    if (hasInvalidCharacters) {
        const fieldsToCheck = GetFieldsToCheck(ctx, value, checkCharRestriction);
        fieldsToCheck.forEach(field => {
            const fieldValue = ctx.formData[field];
            ctx.specialRuleChangeData(field, fieldValue, 'Please remove numbers and/or special characters as they are not acceptable in the provider portal.');
        });
    }
}

export const LLSOnlyAlphabeticSpacesHyphensApostrophesPeriodFieldsAllowedSpecialRule = (value, ctx) => {
    if (!value) return;

    const invalidCharsReg = /[^a-zA-Z \-.']/gm;
    const hasInvalidCharacters = value.match(invalidCharsReg);
    const checkCharRestriction = ['HF_City', 'Applicant_First_Name', 'Applicant_Last_Name', 'HP_First_Name', 'HP_Last_Name',
        'HP_Title', 'HP_City', 'Authorized_First_Name', 'Authorized_Last_Name', 'Authorized_City', 'Patient City', 'Guardian_Name_First', 'Guardian_Name_Last',
        'Guardian_City'];
    //const checkCharMinimumArr2 = ['HP_First_Name', 'HP_Last_Name', 'HP_Title', 'Authorized_First_Name', 'Authorized_Last_Name'];
    //const checkCharMinimumArr3 = ['Applicant_First_Name', 'Applicant_Last_Name', 'Authorized_City'];

    if (hasInvalidCharacters) {
        const fieldsToCheck = GetFieldsToCheck(ctx, value, checkCharRestriction);
        fieldsToCheck.forEach(field => {
            const fieldValue = ctx.formData[field];
            ctx.specialRuleChangeData(field, fieldValue, 'Please remove numbers and/or special characters as they are not acceptable in the provider portal.');
        });
    }
    /*else {
        const fieldsToCheck2 = GetFieldsToCheck(ctx, value, checkCharMinimumArr2);
        fieldsToCheck2.forEach(field => {
            const fieldValue = ctx.formData[field];
            if (fieldValue.trim().length < 2) {
                const fieldLabel = ctx.getFieldDef(field).label;
                ctx.specialRuleChangeData(field, fieldValue, `${fieldLabel} must contain at least 2 characters.`);
            }
        })
        const fieldsToCheck3 = GetFieldsToCheck(ctx, value, checkCharMinimumArr3);
        fieldsToCheck3.forEach(field => {
            const fieldValue = ctx.formData[field];
            if (fieldValue.trim().length < 3) {
                const fieldLabel = ctx.getFieldDef(field).label;
                ctx.specialRuleChangeData(field, fieldValue, `${fieldLabel} must contain at least 3 characters.`);
            }
        })
    }*/
}

export const LLSOnlyAlphabeticSpacesHyphensCommasPeriodSlashFieldsFieldsAllowedSpecialRule = (value, ctx) => {
    if (!value) return;

    const invalidCharsReg = /[^a-zA-Z \-.,/]/gm;
    const hasInvalidCharacters = value.match(invalidCharsReg);
    const checkCharRestriction = ['Race_Specify'];
    if (hasInvalidCharacters) {
        const fieldsToCheck = GetFieldsToCheck(ctx, value, checkCharRestriction);
        fieldsToCheck.forEach(field => {
            const fieldValue = ctx.formData[field];
            ctx.specialRuleChangeData(field, fieldValue, 'Please remove numbers and/or special characters as they are not acceptable in the provider portal.');
        });
    }
}

export const LLSOnlyAlphanumericSpacesAllowedSpecialRule = (value, ctx) => {
    if (!value) return;

    const invalidCharsReg = /[^a-zA-Z0-9 ]/gm;
    const hasInvalidCharacters = value.match(invalidCharsReg);
    const checkCharRestriction = ['Provider Physician Address 1', 'Provider Physician Address 2'];

    if (hasInvalidCharacters) {
        const fieldsToCheck = GetFieldsToCheck(ctx, value, checkCharRestriction);
        fieldsToCheck.forEach(field => {
            const fieldValue = ctx.formData[field];
            ctx.specialRuleChangeData(field, fieldValue, 'Please remove special characters as they are not acceptable in the provider portal.');
        });
    }
}

//holding fields that are not checked in a regex special rule
/*export const LLSEnforceMinimumCharLength2 = (value, ctx) =>{
    const checkCharMinimumArr2 = [];
    const fieldsToCheck2 = GetFieldsToCheck(ctx, value, checkCharMinimumArr2);
    fieldsToCheck2.forEach(field =>{

        const fieldValue = ctx.formData[field];
        if(fieldValue.trim().length < 2){
            const fieldLabel = ctx.getFieldDef(field).label;
            ctx.specialRuleChangeData(field, fieldValue, `${fieldLabel} must contain at least 2 characters.`);
        }
    })
}*/

//holding fields that are not checked in a regex special rule
/*export const LLSEnforceMinimumCharLength3 = (value, ctx) => {
    const checkCharMinimumArr3 = ['HF_Name', 'Provider_Facility_Name', 'Applicant_Position', 'HP_Facility_Name'];
    const fieldsToCheck3 = GetFieldsToCheck(ctx, value, checkCharMinimumArr3);
    fieldsToCheck3.forEach(field => {

        const fieldValue = ctx.formData[field];
        if (fieldValue.trim().length < 3) {
            const fieldLabel = ctx.getFieldDef(field).label;
            ctx.specialRuleChangeData(field, fieldValue, `${fieldLabel} must contain at least 3 characters.`);
        }
    })
}*/


const LLSEmptyFundIfInsuranceChangesSpecialRule = (value, ctx) => {
    const primaryInsuranceField = 'Insurance Patient Insurance Types LLS';
    const field = ctx.getFieldDef(primaryInsuranceField);
    if (field) {
        ctx.specialRuleChangeData('LLS Fund Selection', 'bogus');//hack to get around the falsely evaluation of this in LLSFundSelection component
    }
}

export const LLSReferredByEmailSpecialRule = (value, ctx) => {
    const referredBy = ctx.formData['Referred'];

    if (referredBy === 'Healthcare Facility') {
        CheckEmailValueWhenEmailTypeIsChosen(ctx, 'HF_Email', 'HF_Email_Type');
    }
    else if (referredBy === 'Healthcare Professional') {
        CheckEmailValueWhenEmailTypeIsChosen(ctx, 'HP_Email', 'HP_Email_Type');
    }
}


export const LLSGuardianEmailSpecialRule = (value, ctx) => {
    CheckEmailValueWhenEmailTypeIsChosen(ctx, 'Guardian_Email', 'Guardian_email_type');
}

function CheckEmailValueWhenEmailTypeIsChosen(ctx, emailDKName, emailTypeDKName) {
    const emailValue = ctx.formData[emailDKName];
    const emailType = ctx.formData[emailTypeDKName];
    if (emailValue.length > 0 && (emailType === null || emailType === "")) {
        ctx.specialRuleChangeData(emailTypeDKName, '', 'Email type is required when email address is provided.');
    }
    else if (emailValue.length === 0 && (emailType !== null && emailType !== "")) {
        ctx.specialRuleChangeData(emailDKName, '', 'Email is required when email type is provided.');
    }
    else if (emailValue.length === 0 && (emailType === null || emailType === "")) {
        ctx.specialRuleChangeData(emailDKName, '', '');
        ctx.specialRuleChangeData(emailTypeDKName, '', '');
    }
}

const LLSCopyApplicantToHealthcareProfFields = (value, ctx) => {
    if (value?.toLowerCase() === 'yes') {
        ctx.specialRuleChangeData('HP_First_Name', ctx.formData['Applicant_First_Name']);
        ctx.specialRuleChangeData('HP_Last_Name', ctx.formData['Applicant_Last_Name']);
        ctx.specialRuleChangeData('HP_Phone', ctx.formData['Applicant_Phone_Number']);
        ctx.specialRuleChangeData('HP_Facility_Name', ctx.formData['Provider_Facility_Name']);
        ctx.specialRuleChangeData('HP_Title', ctx.formData['Applicant_Position']);
    }
}

function GetFieldsToCheck(ctx, value, arrToCheckAgainst) {
    const formData = Object.keys(ctx.formData).map(function (key) {
        return [key, ctx.formData[key]];
    })
    var arr = [];
    for (var i = 0; i < formData.length; i++) {
        let dataKey = formData[i][0];
        let dataValue = formData[i][1];
        if (dataValue === value) {
            arr.push(dataKey);
        }
    }
    const intersection = arr.filter(element => arrToCheckAgainst.includes(element));
    return intersection;
}

export const createLLSRules = (meta, ctx) => {
    initLLSAuthorizedContactRule(ctx);
    ctx.createSpecialRule(' Same as Healthcare Professional', LLSCopyApplicantToHealthcareProfFields);
    LLSCopyApplicantToHealthcareProfFields(ctx.formData[' Same as Healthcare Professional'], ctx);

    ctx.createSpecialRule('Patient_Race', LLSOtherPreferNotToDiscloseRace);
    LLSOtherPreferNotToDiscloseRace(ctx.formData['Patient_Race'], ctx);

    ctx.createSpecialRule('Patient_US', LLSLivingInUSSpecialRule);
    LLSLivingInUSSpecialRule(ctx.formData['Patient_US'], ctx);

    ctx.createSpecialRule('Patient_Treatment', LLSActiveTreatmentSpecialRule);
    LLSActiveTreatmentSpecialRule(ctx.formData['Patient_Treatment'], ctx)

    ctx.createSpecialRule('Insurance_Does_Patient_Have_Medical_Insurance', LLSInsuranceCoverageSpecialRule);
    LLSInsuranceCoverageSpecialRule(ctx.formData['Insurance_Does_Patient_Have_Medical_Insurance'], ctx);

    ctx.createSpecialRule('Insurance Patient Insurance Types LLS', LLSEmptyFundIfInsuranceChangesSpecialRule);

    ctx.createSpecialRule('HF_Email', LLSReferredByEmailSpecialRule);
    ctx.createSpecialRule('HF_Email_Type', LLSReferredByEmailSpecialRule);
    LLSReferredByEmailSpecialRule(ctx.formData['HF_Email_Type'], ctx);
    LLSReferredByEmailSpecialRule(ctx.formData['HF_Email'], ctx);

    ctx.createSpecialRule('HP_Email_Type', LLSReferredByEmailSpecialRule);
    ctx.createSpecialRule('HP_Email', LLSReferredByEmailSpecialRule);
    LLSReferredByEmailSpecialRule(ctx.formData['HP_Email_Type'], ctx);
    LLSReferredByEmailSpecialRule(ctx.formData['HP_Email'], ctx);

    ctx.createSpecialRule('Guardian_Email', LLSGuardianEmailSpecialRule);
    ctx.createSpecialRule('Guardian_email_type', LLSGuardianEmailSpecialRule);
    LLSGuardianEmailSpecialRule(ctx.formData['Guardian_Email'], ctx);
    LLSGuardianEmailSpecialRule(ctx.formData['Guardian_email_type'], ctx);

    const alphabeticAndSpacesOnlyFields = ['Provider Physician City', 'Provider Physician Name First', 'Provider Physician Name Last'];
    alphabeticAndSpacesOnlyFields.forEach(field => {
        ctx.createSpecialRule(field, LLSOnlyAlphabeticCharsAndSpacesAllowedSpecialRule);
        LLSOnlyAlphabeticCharsAndSpacesAllowedSpecialRule(ctx.formData[field], ctx);
    });

    const alphabeticSpacesHyphensOnlyFields = ['Insurance Primary Subscriber Name', 'Insurance Secondary Subscriber Name'];
    alphabeticSpacesHyphensOnlyFields.forEach(field => {
        ctx.createSpecialRule(field, LLSOnlyAlphabeticCharsSpacesHyphensAllowedSpecialRule);
        LLSOnlyAlphabeticCharsSpacesHyphensAllowedSpecialRule(ctx.formData[field], ctx);
    });

    const alphabeticSpacesHyphensApostrophesOnlyFields = ['Patient Name First', 'Patient Name Last'];
    alphabeticSpacesHyphensApostrophesOnlyFields.forEach(field => {
        ctx.createSpecialRule(field, LLSOnlyAlphabeticSpacesHyphensApostrophesAllowedSpecialRule);
        LLSOnlyAlphabeticSpacesHyphensApostrophesAllowedSpecialRule(ctx.formData[field], ctx);
    });

    const alphabeticSpacesHyphensApostrophesPeriodFields = ['HF_City', 'Applicant_First_Name', 'Applicant_Last_Name', 'HP_First_Name', 'HP_Last_Name',
        'HP_Title', 'HP_City', 'Authorized_First_Name', 'Authorized_Last_Name', 'Authorized_City', 'Patient City', 'Guardian_Name_First', 'Guardian_Name_Last',
        'Guardian_City'];
    alphabeticSpacesHyphensApostrophesPeriodFields.forEach(field => {
        ctx.createSpecialRule(field, LLSOnlyAlphabeticSpacesHyphensApostrophesPeriodFieldsAllowedSpecialRule);
        LLSOnlyAlphabeticSpacesHyphensApostrophesPeriodFieldsAllowedSpecialRule(ctx.formData[field], ctx);
    });

    const alphabeticSpacesHyphensCommasPeriodSlashFields = ['Race_Specify'];
    alphabeticSpacesHyphensCommasPeriodSlashFields.forEach(field => {
        ctx.createSpecialRule(field, LLSOnlyAlphabeticSpacesHyphensCommasPeriodSlashFieldsFieldsAllowedSpecialRule);
        LLSOnlyAlphabeticSpacesHyphensCommasPeriodSlashFieldsFieldsAllowedSpecialRule(ctx.formData[field], ctx);
    });

    const alphanumericSpacesHyphensOnlyFields = ['Insurance Primary Medical Insurance ID_Policy Number', 'Insurance Primary Medical Insurance Group Number',
        'Insurance Secondary Medical Insurance ID_Policy Number', 'Insurance Secondary Medical Insurance Group Number', 'HF_Name', 'HP_Facility_Name'];
    alphanumericSpacesHyphensOnlyFields.forEach(field => {
        ctx.createSpecialRule(field, LLSOnlyAlphanumericSpacesHyphensAllowedSpecialRule);
        LLSOnlyAlphanumericSpacesHyphensAllowedSpecialRule(ctx.formData[field], ctx);
    });
    const alphanumericSpacesOnlyFields = ['Provider Physician Address 1', 'Provider Physician Address 2'];
    alphanumericSpacesOnlyFields.forEach(field => {
        ctx.createSpecialRule(field, LLSOnlyAlphanumericSpacesAllowedSpecialRule);
        LLSOnlyAlphanumericSpacesAllowedSpecialRule(ctx.formData[field], ctx);
    });

    const alphanumericHashHyphenSlashPeriodCommaFields = ['HF_Address1', 'HF_Address2', 'HP_Address1', 'HP_Address2', 'Authorized_Address_1', 'Authorized_Address_2', 'Patient Address 1',
        'Patient Address 2', 'Guardian_Address1', 'Guardian_Address2'];
    alphanumericHashHyphenSlashPeriodCommaFields.forEach(field => {
        ctx.createSpecialRule(field, LLSOnlyAlphanumericHashHyphenSlashPeriodCommaFields);
        LLSOnlyAlphanumericHashHyphenSlashPeriodCommaFields(ctx.formData[field], ctx);
    });


    const alphabeticHashHyphenSlashPeriodCommaFields = ['Refferred_Other'];
    alphabeticHashHyphenSlashPeriodCommaFields.forEach(field => {
        ctx.createSpecialRule(field, LLSOnlyAlphabeticHashHyphenSlashPeriodCommaFields);
        LLSOnlyAlphabeticHashHyphenSlashPeriodCommaFields(ctx.formData[field], ctx);
    });

    /*const mimimumCharFields3 = ['Applicant_Position', 'Provider_Facility_Name']
    mimimumCharFields3.forEach(field => {
        ctx.createSpecialRule(field, LLSEnforceMinimumCharLength3);
        LLSEnforceMinimumCharLength3(ctx.formData[field], ctx);
    });*/
}
